import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  Container, Button, Form, Modal 
} from "react-bootstrap";
import FocusTrap from "focus-trap-react";
import CloseIcon from "../../assets/images/close-icon.svg";
import Radio from "../common/Radio";

const ChangeLanguagePopup = (props) => {
  const { t } = useTranslation();
  const {
    onClose,
    availableLanguages,
    selectedLanguage,
    onLanguageChange
  } = props;

  const [selectedOption, setSelectedOption] = useState(
    selectedLanguage || "en_US"
  );

  const onOptionsChange = (value) => {
    setSelectedOption(value);
  };

  const onNext = (e) => {
    e.preventDefault();
    if (selectedLanguage !== selectedOption) {
      onLanguageChange(selectedOption);
    }
    onClose();
  };

  return (
    <Modal
      show
      animation={false}
      onEscapeKeyDown={() => onClose()}
    >
      <FocusTrap>
        <div className="popup change-mobile-number">
          <Container fluid>
            <div className="popup__wrapper">
              <Form>
                <div className="popup__wrapper-body">
                  <div className="popup__wrapper-body-header">
                    <h6>{t("pages.changePreferredLang.changeLanguage")}</h6>
                    <Button
                      className="popup__wrapper-body-header-close"
                      onClick={() => {
                        onClose();
                      }}
                      variant="light"
                      aria-label="Close"
                    >
                      <img src={CloseIcon} alt="" />
                    </Button>
                  </div>
                  <>
                    <p className="popup__wrapper-body-desc">
                      {t("pages.changePreferredLang.selectLanguage")}
                    </p>
                    {availableLanguages.map((language, index) => (
                      <Radio
                        key={language}
                        name={`language-${language}`}
                        label={`pages.changePreferredLang.languages.${language}`}
                        value={language}
                        isChecked={language === selectedOption}
                        handleChange={onOptionsChange}
                      />
                    ))}
                  </>
                </div>
                <div className="popup__wrapper-footer">
                  <Button
                    className="wrapper__container-card-body-submit"
                    size="lg"
                    variant="primary"
                    block
                    type="submit"
                    onClick={(e) => onNext(e)}
                  >
                    {t("pages.changePreferredLang.changeLanguage")}
                  </Button>
                </div>
              </Form>
            </div>
          </Container>
        </div>
      </FocusTrap>
    </Modal>
  );
};

ChangeLanguagePopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  selectedLanguage: PropTypes.string.isRequired,
  availableLanguages: PropTypes.array.isRequired,
  onLanguageChange: PropTypes.func.isRequired
};
export default ChangeLanguagePopup;
